import View from "./barcodes.view";
import Presenter from "./barcodes.presenter";
import { ConnectComponent } from "util";

export default ConnectComponent(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/general-info/barcodes/index.js